export const TAIWAN_COUNTRY_ID = 77;
export const TAIWAN_CAMPAIGN_CREATION_RESTRICTED_MESSAGE =
  'You are not allowed to create Taiwan campaigns';

const normalizeEmail = (email?: string): string =>
  String(email || '').trim().toLowerCase();

export const isTaiwanCampaignCreationAllowed = (
  countryID: number | string | undefined,
  userEmail?: string,
): boolean => {
  if (Number(countryID) !== TAIWAN_COUNTRY_ID) {
    return true;
  }

  const isAllowedAll = (window as any).Grab?.config?.PORTAL_CONFIG?.holos
    ?.isTaiwanCampaignCreationAllowedAll;

  if (isAllowedAll !== false) {
    return true;
  }

  const whitelistedCreators = (window as any).Grab?.config?.PORTAL_CONFIG
    ?.holos?.whitelistedTaiwanCampaignCreators;
  const normalizedUserEmail = normalizeEmail(userEmail);

  return Boolean(
    normalizedUserEmail
    && Array.isArray(whitelistedCreators)
    && whitelistedCreators.some(
      (creatorEmail) => normalizeEmail(creatorEmail) === normalizedUserEmail,
    ),
  );
};
